import { jsx } from "react/jsx-runtime";
import { memo, forwardRef, useId } from "react";
import { ControlBody } from "../common/ControlBody.js";
import { InputBase } from "./Input/InputBase.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
const InputControl = memo(
  forwardRef(
    ({
      type = "text",
      placeholder,
      sx,
      startAdornment,
      inputRef,
      uncontrolled,
      maxlength,
      onChange,
      value,
      label,
      error,
      tip,
      optional,
      name,
      className,
      disabled,
      hideTipText,
      onBlur,
      compact = !0,
      size = "md",
      readOnly,
      max,
      ignoreLabelHeight,
      autoComplete,
      noClearHandler,
      errorViewType,
      inputContainerRef,
      ...props
    }, ref) => {
      const id = useId();
      return /* @__PURE__ */ jsx(
        ControlBody,
        {
          sx,
          label,
          error,
          errorViewType,
          tip,
          optional,
          className,
          disabled,
          hideTipText,
          compact,
          size,
          ignoreLabelHeight,
          "data-test-id": inheritDataTestId(props),
          children: /* @__PURE__ */ jsx(
            InputBase,
            {
              ref: inputContainerRef,
              "data-test-id": DATA_TEST_ID_INHERITED,
              noClearHandler,
              autoComplete,
              max,
              size,
              className,
              onChange,
              onBlur,
              disabled,
              name,
              id,
              value: uncontrolled ? void 0 : value,
              error: !!error,
              type,
              placeholder,
              inputRef: inputRef ?? ref,
              maxLength: maxlength,
              readOnly,
              startAdornment,
              ...props
            }
          )
        }
      );
    }
  )
);
InputControl.displayName = "InputControl";
export {
  InputControl
};
//# sourceMappingURL=InputControl.js.map
